import { render } from "./NextStepsGroup.vue?vue&type=template&id=4b2a3b96&scoped=true"
import script from "./NextStepsGroup.vue?vue&type=script&lang=js"
export * from "./NextStepsGroup.vue?vue&type=script&lang=js"

import "./NextStepsGroup.vue?vue&type=style&index=0&id=4b2a3b96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2a3b96"]])

export default __exports__